import axios from 'axios'
import Vue from 'vue'
import SortService from '@/services/sort.service'

export default {
    namespaced: true,
    state: {
        loadingRawLead: false,
        rawLeads: [],
    },
    mutations: {
        SET_LOADING_RAW_LEADS(state, loadingRawLead) {
            state.loadingRawLead = loadingRawLead;
        },
        SET_RAW_LEADS(state, rawLeads) {
            state.rawLeads = rawLeads;
        },
        SOCKET_RAW_LEAD_ADD(state, rawLead) {
            state.rawLeads = [...state.rawLeads, rawLead];
        },
        REALTIME_UPDATE_LEAD(state, { lead, index }) {
            state.leads[index] = lead;
            Vue.set(state.leads, index, state.leads[index]);
        }
    },
    getters: {
        rawLeads(state) {
            return state.loadingRawLead === false ? state.rawLeads : [];
        },
        loadingRawLeads(state) {
            return state.loadingRawLead;
        }
    },
    actions: {
        loadRawLeads({ commit }) {
            commit("SET_LOADING_RAW_LEADS", true);

            axios.get(`lead/raws`,)
                .then(res => {
                    commit("SET_RAW_LEADS", res.data.rawLeads);
                    commit("SET_LOADING_RAW_LEADS", false);
                })
                .catch(e => {
                    console.log(e);
                    commit("SET_LOADING_RAW_LEADS", false);
                })
        },
        "SOCKET_UPDATE_RAW_LEADS"({ commit, state }, data) {
            const sortedLead = data.type_id === 2 ? SortService.sortLead(data) : SortService.sortHealthLead(data);
            const index = state.leads.findIndex(lead => lead.id === sortedLead.id);

            commit("REALTIME_UPDATE_LEAD", {
                lead: sortedLead,
                index
            })
        }
    },
}
